<template>
  <div class="validator">
    <template v-if="type && codeSent">
      <h5 v-if="type == 'telefonecelular'">Insira o código enviado por sms para o número {{ content.destination }}</h5>
      <h5 v-if="type == 'email'">Insira o código enviado por email para {{ content.destination }}</h5>
    </template>
    <h5 v-else-if="codeError">
     {{ errorMessage }}
    </h5>
    <ul v-if="codigo && codeSent">
      <li>
        <input 
          v-model="codigo[0]" 
          type="number" 
          maxlength="1" 
          @paste="colarCodigo"
          @input="proximoCampo(0, $event)"
        />
      </li>
      <li>
        <input 
          v-model="codigo[1]" 
          type="number" 
          maxlength="1"
          @input="proximoCampo(1, $event)"
          @keydown.backspace="campoAnterior(1, $event)"
        />
      </li>
      <li>
        <input 
          v-model="codigo[2]" 
          type="number" 
          maxlength="1"
          @input="proximoCampo(2, $event)"
          @keydown.backspace="campoAnterior(2, $event)"
        />
      </li>
      <li>
        <input 
          v-model="codigo[3]" 
          type="number" 
          maxlength="1"
          @input="proximoCampo(3, $event)"
          @keydown.backspace="campoAnterior(3, $event)"
        />
      </li>
      <li>
        <input 
          v-model="codigo[4]" 
          type="number" 
          maxlength="1"
          @input="proximoCampo(4, $event)"
          @keydown.backspace="campoAnterior(4, $event)"
        />
      </li>
      <li>
        <input 
          v-model="codigo[5]" 
          type="number" 
          maxlength="1"
          @input="runValidation()"
          @keydown.backspace="campoAnterior(5, $event)"
        />
      </li>
    </ul>
    <div v-if="codigo && codeError">
      
    </div>
    <div class="actionWrap">
      <div v-if="readyForNext || codeError">
        <a href="#" @click.prevent="sendCode()" class="color-primary">Reenviar código</a>
      </div>
      <div v-else-if="!codeError">
        Você poderá reenviar o código em {{ timer }}
      </div>
    </div>
  </div>
</template>

<script>
import matriculaService from '@/services/matricula.service'

export default {
  props: {
    type: String,
    content: Object
  },
  data () {
    return {
      codigo: ['','','','','',''],
      tempoEspera: 60,
      timer: '00:00',
      timerSeconds: 0,
      readyForNext: false,
      timerInterval: null,
      codeSent: false,
      codeError: false,
      errorMessage: null
    }
  },
  mounted () {
    this.sendCode()
  },
  beforeUnmount () {
    this.clearTimer()
    this.codeSent = false
    this.codeError = false
  },
  methods: {
    runTimer () {
      this.clearTimer()
      this.timerSeconds = this.tempoEspera
      this.timer = this.formatTimer(this.timerSeconds)
      this.readyForNext = false

      this.timerInterval = setInterval(() => {
        this.timerSeconds--
        this.timer = this.formatTimer(this.timerSeconds)

        if (this.timerSeconds === 0) {
          this.readyForNext = true
          this.clearTimer()
        }
      }, 1000)
    },
    formatTimer (seconds) {
      const safeSeconds = Math.max(seconds, 0)
      const hours = Math.floor(safeSeconds / 3600)
      const minutes = Math.floor((safeSeconds % 3600) / 60)
      const remainingSeconds = safeSeconds % 60

      if (hours) {
        return [
          hours,
          minutes,
          remainingSeconds
        ].map(unit => unit.toString().padStart(2, '0')).join(':')
      }

      return [
        minutes,
        remainingSeconds
      ].map(unit => unit.toString().padStart(2, '0')).join(':')
    },
    clearTimer () {
      if (this.timerInterval) {
        clearInterval(this.timerInterval)
        this.timerInterval = null
      }
    },
    colarCodigo (event) {
      event.preventDefault()

      const texto = event.clipboardData.getData('text')
      const numeros = texto.replace(/\D/g, '').slice(0, 6).split('')

      if (numeros.length === 6) {
        this.codigo = numeros

        this.$nextTick(() => {
          event.target
            .closest('ul')
            .querySelectorAll('input')[5]
            .focus()

          this.runValidation()
        })
      }
    },
    proximoCampo (index, event) {
      const valor = event.target.value.replace(/\D/g, '').slice(0, 1)

      this.codigo[index] = valor

      if (valor && index < 5) {
        this.$nextTick(() => {
          event.target
            .closest('ul')
            .querySelectorAll('input')[index + 1]
            .focus()
        })
      }
    },
    campoAnterior (index, event) {
      if (index > 0 && !this.codigo[index]) {
        event.preventDefault()

        this.$nextTick(() => {
          event.target
            .closest('ul')
            .querySelectorAll('input')[index - 1]
            .focus()
        })
      }
    },
    sendCode () {
      if ( this.type == 'email' ) {
        matriculaService.validaEmail(this.content)
        .then ( response => {
          this.runTimer()
          this.codeSent = true
          console.log('response:', response)
        })
        .catch ( error => {
          console.error(error)
          this.codeError = true
          this.errorMessage = error.response.data.error.message
        })
        .finally ( () => {

        })
      }
      if ( this.type == 'telefonecelular' ) {
        matriculaService.validaTelefone(this.content)
        .then ( response => {
          this.runTimer()
          this.codeSent = true
          console.log('response:', response)
        })
        .catch ( error => {
          console.error(error)
          this.codeError = true
          this.errorMessage = error.response.data.error.message
        })
        .finally ( () => {

        })
      }
    },
    runValidation () {
      const code = this.codigo.join('')
      // const { idPessoa } = this.content
      const drop = {
        code,
        ...this.content
      }

      console.log("runValidation - code:", code)
      if ( this.type == 'email' && code.length == 6 ) {
        window.spinner.emit("open")
        matriculaService.validaCodigoEmail(drop)
        .then ( response => {
          console.log('response:', response)
          this.$emit('validated', this.type)
        })
        .catch ( error => {
          console.error(error)
        })
        .finally ( () => {
          window.spinner.emit("close")
        })
      }
      if ( this.type == 'telefonecelular' && code.length == 6 ) {
        window.spinner.emit("open")
        matriculaService.validaCodigoTelefone(drop)
        .then ( response => {
          console.log('response:', response)
          this.$emit('validated', this.type)
        })
        .catch ( error => {
          console.error(error)
        })
        .finally ( () => {
          window.spinner.emit("close")
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .validator {
    padding: $mg_mini;

    h5 {
      font-size: $font-size-small;
      text-align: center;
      margin-bottom: $hmg_mid;
    }

    ul {
      width: 100%;
      padding: 0;
      margin: 0;
      display: flex;
      align-content: center; align-items: center;
      justify-content: center;
      gap: $hmg_mini;

      li {
        width: 16%;
        padding: 0; margin: 0;
        list-style: none;

        input {
          width: 100%;
          height: 50px;
          border-radius: $border-radius-small;
          border: $border-component;
          text-align: center;
          font-size: 2rem;
          font-weight: bold;
          color: $color-text;
          @extend %transition_3e;

          &:focus {
            outline: 2px solid $color-primary;
          }
        }
      }
    }

    .actionWrap {
      margin-top: $hmg_mid;
      text-align: center;
    }
  }
</style>
